import QueryBuilder from './Utilities/queryBuilder';

/**
 * Contains the relative URL for all APIS called directly.
 */
export const API_URLS = {
	email: {
		send: () => QueryBuilder.Create(`/email`).toString(),
	},

	contact: {
		getCsr: () => QueryBuilder.Create(`/contacts/csrs`).toString(),
		getCsrDetail: () =>
			QueryBuilder.Create(`/contacts/csrs/details`).toString(),
	},

	documents: {
		getFile: ({ fileName, id }) =>
			QueryBuilder.Create(`/documents/download`)
				.withParam('fileName', fileName)
				.withParam('id', id)
				.toString(),
	},

	order: {
		getDashboard: () => QueryBuilder.Create(`/orders/dashboard`).toString(),
		getOrderList: () => QueryBuilder.Create(`/orders/list`).toString(),

		downloadOrderList: ({ format }) =>
			QueryBuilder.Create(`/orders/list/export`)
				.withParam('format', format)
				.toString(),

		getOrderDetail: ({ orderNumber }) =>
			QueryBuilder.Create(`/orders/details`)
				.withParam('orderNumber', orderNumber)
				.toString(),

		getShipmentVisibility: ({ OrderNumber, BOLNumber }) =>
			QueryBuilder.Create(`/orders/shipments/visibility`)
				.withParam('orderNumber', OrderNumber)
				.withParam('bolNumber', BOLNumber)
				.toString(),
	},

	orderRequest: {
		submitOrderRequest: () => QueryBuilder.Create(`/order-requests`).toString(),
	},

	product: {
		getProductList: () => QueryBuilder.Create(`/products/list`).toString(),

		downloadProductList: ({ format }) =>
			QueryBuilder.Create(`/products/list/export`)
				.withParam('format', format)
				.toString(),

		downloadPrintCard: (productId) =>
			QueryBuilder.Create(`/products/${productId}/print-card`).toString(),

		getProductDetails: ({ productId }) =>
			QueryBuilder.Create(`/products/details`)
				.withParam('productId', productId)
				.toString(),
	},

	liveList: {
		get: ({ listName }) =>
			QueryBuilder.Create(`/live-lists`)
				.withParam('listName', listName)
				.toString(),
	},

	search: {
		search: () => QueryBuilder.Create(`/search`).toString(),

		getSearchSuggestions: () =>
			QueryBuilder.Create(`/search/suggestions`).toString(),
	},

	user: {
		getProfile: (userId) =>
			QueryBuilder.Create(`/users/${userId}/profile`).toString(),

		updateProfile: (userId) =>
			QueryBuilder.Create(`/users/${userId}/profile`).toString(),

		getAccounts: (userId) =>
			QueryBuilder.Create(`/users/${userId}/accounts`).toString(),

		getAccountDetails: (userId, accountId) =>
			QueryBuilder.Create(
				`/users/${userId}/accounts/${accountId}/details`
			).toString(),

		impersonate: (userId) =>
			QueryBuilder.Create(`/users/${userId}/impersonate`).toString(),

		getNavFilters: () => QueryBuilder.Create(`/users/nav-filters`).toString(),

		getProductFilters: () =>
			QueryBuilder.Create(`/users/product-filters`).toString(),
	},
};
